import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import Axis from "../../../../images/axis.svg";
import Curves from "../../../../images/curves.svg";
import SwLine from "../../../../images/Price-ceilingLine.svg";
import horGreen from "../../../../images/horGreen1.svg";
import horRed from "../../../../images/horRed.svg";
import vertRed from "../../../../images/vertRed.svg";
import vertRedHalf from "../../../../images/vertRedHalf.svg";
import vertwhiteHalf from "../../../../images/Qo-white.png";

import horWhiteHalf from "../../../../images/Hor-white-CSPS-2.svg";
import horBlueHalf from "../../../../images/Hor-blue-CSPS.svg";
import horGreenHalf from "../../../../images/Hor-green-CSPS.svg";
import horRedHalf from "../../../../images/Hor-red-CSPS.svg";


// import Qd2White from "../../../../images/Qd2White.svg";
import Q1WhiteCSPS from "../../../../images/Q1White-CSPS.svg";
import QoWhite from "../../../../images/QoWhite.svg";

import Q2WhiteCSPS from "../../../../images/Q2White-CSPS.svg";
import HorBlue from "../../../../images/Hor-white3.png";
// import HorWhite from "../../../../images/horWhite1.svg";
import Powhite from "../../../../images/Powhite-CSPS-half.svg";

// import VertWhite from "../../../../images/vertWhite.svg";
import QdHalfBlue from "../../../../images/QdBlue.svg";
// import QdHalfBlue from "../../../../images/QdBlue.svg";

import HalfBlue from "../../../../images/Qd2BlueHalf.svg";
import VertGreenHalf from "../../../../images/VertGreenHalf.svg";
import { mergeClasses } from "@material-ui/styles";

const SecondGraph = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setPhase2Answers,
    setAnswers,
    answers,
    phase2Answers,
  } = props;

  const [onSelect, setOnSelect] = useState(-1);
  const [selected, setSelected] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);

  const [horBlueLine, setHorBlueLine] = useState(false);
  const [vertBlueLine, setVertBlueLine] = useState(false);

  const [verticleBlueHalf1, setVerticleBlueHalf1] = useState(false);
  const [vertRedHalf1, setVertRedHalf1] = useState(false);
  const [verticleGreenHalf1, setVerticleGreenHalf1] = useState(false);

  const [verticleBlueHalf2, setVerticleBlueHalf2] = useState(false);
  const [vertRedHalf2, setVertRedHalf2] = useState(false);
  const [verticleGreenHalf2, setVerticleGreenHalf2] = useState(false);

  const [verticleBlueHalf21, setVerticleBlueHalf21] = useState(false);
  const [vertRedHalf21, setVertRedHalf21] = useState(false);
  const [verticleGreenHalf21, setVerticleGreenHalf21] = useState(false);

  const [verticleBlueHalf22, setVerticleBlueHalf22] = useState(false);
  const [vertRedHalf22, setVertRedHalf22] = useState(false);
  const [verticleGreenHalf22, setVerticleGreenHalf22] = useState(false);

  const [vert1HalfBlue, setVert1HalfBlue] = useState(false);
  const [vert2HalfBlue, setVert2HalfBlue] = useState(false);
  const [vert3HalfBlue, setVert3HalfBlue] = useState(false);

  const [horGreenLine, setHorGreenLine] = useState(false);
  const [vertGreenHalfLine, setVertGreenHalfLine] = useState(false);

  const [horRedLine, setHorRedLine] = useState(false);
  const [vertRedLine, setVertRedLine] = useState(false);

  const [vertRedHalfLine, setVertRedHalfLine] = useState(false);
  const [vertRedHalf2Line, setVertRedHalf2Line] = useState(false);
  const [vertRedHalf3Line, setVertRedHalf3Line] = useState(false);
  const [vertRedHalf4Line, setVertRedHalf4Line] = useState(false);

  const [Qd2WhiteLine, setQd2WhiteRedLine] = useState(false);

  const _onMouseMove = (e) => {
    // console.log(e.screenX - e.screenY);
    // this.setState({ x: e.screenX, y: e.screenY });
  };

  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#fff";
    }
  };

  console.log("onSelect", onSelect);

  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      if (!submitted && selected.includes(21) && selected.includes(5)) {
        setHorBlueLine(true);
      } else {
        setHorBlueLine(false);
      }
      if (!submitted && selected.includes(2) && selected.includes(21)) {
        setVerticleBlueHalf1(true);
      } else {
        setVerticleBlueHalf1(false);
      }

      if (!submitted && selected.includes(21) && selected.includes(22)) {
        setVerticleBlueHalf21(true);
      } else {
        setVerticleBlueHalf21(false);
      }

      if (!submitted && selected.includes(22) && selected.includes(51)) {
        setVerticleBlueHalf22(true);
      } else {
        setVerticleBlueHalf22(false);
      }

      if (!submitted && selected.includes(5) && selected.includes(51)) {
        setVerticleBlueHalf2(true);
      } else {
        setVerticleBlueHalf2(false);
      }

      if (!submitted && selected.includes(6) && selected.includes(7)) {
        setVertBlueLine(true);
      } else {
        setVertBlueLine(false);
      }

      if (!submitted && selected.includes(9) && selected.includes(10)) {
        setVert2HalfBlue(true);
      } else {
        setVert2HalfBlue(false);
      }

      if (!submitted && selected.includes(10) && selected.includes(11)) {
        setVert1HalfBlue(true);
      } else {
        setVert1HalfBlue(false);
      }

      if (!submitted && selected.includes(11) && selected.includes(12)) {
        setVert3HalfBlue(true);
      } else {
        setVert3HalfBlue(false);
        console.log("selected", triangle);
      }
    }
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };

  useEffect(() => {
    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });
    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted) {
      let tempAnswer = answers;
      if (answer) {
        tempAnswer.push(true);
        setAnswers(tempAnswer);
        if (
          questionAnswer.answer.includes(2) &&
          questionAnswer.answer.includes(5)
        ) {
          setHorBlueLine(false);
          setHorGreenLine(true);
        }
        if (
          questionAnswer.answer.includes(6) &&
          questionAnswer.answer.includes(7)
        ) {
          setVertBlueLine(false);
          setVertGreenHalfLine(true);
        }
        if (
          questionAnswer.answer.includes(2) &&
          questionAnswer.answer.includes(21)
        ) {
          setVerticleGreenHalf1(true);
          setVerticleBlueHalf1(false);
        }
        if (
          questionAnswer.answer.includes(21) &&
          questionAnswer.answer.includes(5)
        ) {
          setHorBlueLine(false);
          setHorGreenLine(true);
        }
        if (
          questionAnswer.answer.includes(22) &&
          questionAnswer.answer.includes(51)
        ) {
          setVerticleBlueHalf22(false);
          setVerticleGreenHalf22(true);
        }
        setAnsweredCorrectly(true);
      } else {
        tempAnswer.push(false);
        setAnswers(tempAnswer);
        let is_partial = false;
        if (selected.length < questionAnswer.answer.length) {
          is_partial = notQuiteFun();
          // selected.map((ans) => {
          //   is_partial = true;
          //   if (!questionAnswer.answer.includes(ans)) {
          //     is_partial = false;
          //   }
          // });
        }
        if (is_partial) {
          setAnsweredPartialy(true);
        } else {
          setAnsweredPartialy(false);
          setAnsweredCorrectly(false);
        }
        if (
          questionAnswer.answer.includes(2) &&
          questionAnswer.answer.includes(21)
        ) {
          setVerticleBlueHalf1(false)
          setVertRedHalf1(false);
          setVerticleGreenHalf1(true);
        }
        if (
          questionAnswer.answer.includes(6) &&
          questionAnswer.answer.includes(7)
        ) {
          setVertRedHalf4Line(false);
          setVertBlueLine(false);
          setVertGreenHalfLine(true);
        }
        if ((selected.includes(21) || selected.includes(5)) || (questionAnswer.answer.includes(21) && questionAnswer.answer.includes(5))) {
          if (
            questionAnswer.answer.includes(21) &&
            questionAnswer.answer.includes(5)
          ) {
            setHorBlueLine(false);
            setHorGreenLine(true);
          }
          else {

            if(selected.includes(21) && questionAnswer.answer.includes(21)){
              setHorBlueLine(false);
              setHorGreenLine(true);
            }
            else if(selected.includes(5) && questionAnswer.answer.includes(5)){
              setHorBlueLine(false);
              setHorGreenLine(true);
            }else{
              setHorBlueLine(false);
              setHorRedLine(true);
            }

          }
        }
        if ((selected.includes(2) || selected.includes(21)) || (questionAnswer.answer.includes(2) && questionAnswer.answer.includes(21))) {
          if (
            questionAnswer.answer.includes(2) &&
            questionAnswer.answer.includes(21)
          ) {
            setVerticleBlueHalf1(false);
            setVerticleGreenHalf1(true);
          } else {

            if(selected.includes(21) && questionAnswer.answer.includes(21)){
              setVerticleBlueHalf1(false);
              setVerticleGreenHalf1(true);
            }
            else if(selected.includes(2) && questionAnswer.answer.includes(2)){
              setVerticleBlueHalf1(false);
              setVerticleGreenHalf1(true);
            }else{
              setVerticleBlueHalf1(false);
              setVertRedHalf1(true);
            }

          }
        }
        if (selected.includes(21) || selected.includes(22)) {
          if (
            questionAnswer.answer.includes(21) &&
            questionAnswer.answer.includes(22)
          ) {
            setVerticleBlueHalf21(false);
            setVerticleGreenHalf21(true);
          } else {

            if(selected.includes(21) && questionAnswer.answer.includes(21)){
              setVerticleBlueHalf21(false);
              setVerticleGreenHalf21(true);
            }
            else if(selected.includes(22) && questionAnswer.answer.includes(22)){
              setVerticleBlueHalf21(false);
              setVerticleGreenHalf21(true);
            }else{
              setVerticleBlueHalf21(false);
              setVertRedHalf21(true);
            }

          }
        }
        if ((selected.includes(22) || selected.includes(51)) || ( questionAnswer.answer.includes(22) && questionAnswer.answer.includes(51)) ) {
          if (
            questionAnswer.answer.includes(22) &&
            questionAnswer.answer.includes(51)
          ) {
            setVerticleBlueHalf22(false);
            setVerticleGreenHalf22(true);
          }
           else {
            if(selected.includes(51) && questionAnswer.answer.includes(51)){
              setVerticleBlueHalf22(false);
              setVerticleGreenHalf22(true);
            }
            else if(selected.includes(22) && questionAnswer.answer.includes(22)){
              setVerticleBlueHalf22(false);
              setVerticleGreenHalf22(true);
            }else{
              setVerticleBlueHalf22(false);
              setVertRedHalf22(true);
            }
          }
        }
        if (selected.includes(5) || selected.includes(51)) {
          if (
            questionAnswer.answer.includes(5) &&
            questionAnswer.answer.includes(51)
          ) {
            setVerticleBlueHalf2(false);
            setVerticleGreenHalf2(true);
          } else {
            if(selected.includes(51) && questionAnswer.answer.includes(51)){
              setVerticleBlueHalf2(false);
              setVerticleGreenHalf2(true);
            }
            else if(selected.includes(5) && questionAnswer.answer.includes(5)){
              setVerticleBlueHalf2(false);
              setVerticleGreenHalf2(true);
            }else{
              setVerticleBlueHalf2(false);
              setVertRedHalf2(true);
            }

          }
        }
        if (selected.includes(9) && selected.includes(10)) {
          // red horizontal line
          setVertRedHalfLine(true);
        }
        if (selected.includes(10) && selected.includes(11)) {
          // red horizontal7.5line
          setVertRedHalf2Line(true);
        }
        if (selected.includes(6) || selected.includes(7)) {
          if (
            questionAnswer.answer.includes(6) &&
            questionAnswer.answer.includes(7)
          ) {
            setVertRedHalf4Line(false);
            setVertBlueLine(false);
            setVertGreenHalfLine(true);
          } else {
            if(selected.includes(6) && questionAnswer.answer.includes(6)){
              setVertRedHalf4Line(false);
              setVertBlueLine(false);
              setVertGreenHalfLine(true);
            }
            else if(selected.includes(7) && questionAnswer.answer.includes(7)){
              setVertRedHalf4Line(false);
              setVertBlueLine(false);
              setVertGreenHalfLine(true);
            }else{
              setVertBlueLine(false);
              setVertRedHalf4Line(true);
            }

          }
        }
        if (selected.includes(11) && selected.includes(12)) {
          // red horizontal line
          setVert3HalfBlue(false);
          setVertRedHalf3Line(true);
        }
      }
    }
  }, [submitted]);

  // useEffect(() => {
  //   if (horGreenLine) {
  //     setAnsweredCorrectly(true);
  //   } else {
  //     setAnsweredCorrectly(false);
  //   }
  // }, [horGreenLine]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.internationalContainerMajor}>
        <div
          className={classes.internationalContainerChild}
          onMouseMove={_onMouseMove}
        >
          <img src={Axis} style={{ height: "100%", zIndex: 2 }} alt="" />
          <img
            src={Curves}
            style={{ height: "100%", position: "absolute", zIndex: 2 }}
            alt=""
          />
          <img
            src={SwLine}
            style={{
              height: "9.5%",
              position: "absolute",
              zIndex: 2,
              marginLeft: "6.5%",
              paddingTop: "57%",
            }}
            alt=""
          />

          <img className={classes.HoriWhiteHalf1} src={horWhiteHalf} alt="" />
          <img className={classes.HoriWhiteHalf1} src={horBlueHalf}
          style={{
            zIndex: verticleBlueHalf1 ? 1 : -1,
          }}
          alt="" />
          <img className={classes.HoriWhiteHalf1} src={horGreenHalf}
          style={{
            zIndex: verticleGreenHalf1 ? 1 : -1,
          }}
          alt="" />
          <img className={classes.HoriWhiteHalf1} src={horRedHalf} 
          style={{
            zIndex: vertRedHalf1 ? 1 : -1,
          }}
          alt="" />


          <img className={classes.vertWhiteHalf1} src={vertwhiteHalf} alt="" />
          <img
            className={classes.verticleBlueHalf1}
            src={HalfBlue}
            style={{
              zIndex: verticleBlueHalf21 ? 1 : -1,
            }}
            alt=""
          />

          <img
            src={vertRedHalf}
            className={classes.vertRedHalf1}
            style={{
              zIndex: vertRedHalf21 ? 1 : -1,
            }}
            alt=""
          />
          <img
            className={classes.verticleGreenHalf1}
            src={VertGreenHalf}
            style={{
              zIndex: verticleGreenHalf21 ? 1 :  -1,
            }}
            alt=""
          />

          <img className={classes.vertWhiteHalf2} src={vertwhiteHalf} alt="" />
          <img
            className={classes.verticleBlueHalf2}
            src={HalfBlue}
            style={{
              zIndex: verticleBlueHalf2 ? 1 : -1,
            }}
            alt=""
          />

          <img
            src={vertRedHalf}
            className={classes.vertRedHalf2}
            style={{
              zIndex: vertRedHalf2 ? 1 : -1,
            }}
            alt=""
          />
          <img
            className={classes.verticleGreenHalf2}
            src={VertGreenHalf}
            style={{
              zIndex: verticleGreenHalf2 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.poWhite} src={Powhite} alt="" />

          <img className={classes.vertWhiteHalf} src={vertwhiteHalf} alt="" />

          <img
            src={vertRedHalf}
            className={classes.vertRedHalf}
            style={{
              zIndex: vertRedHalf4Line ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.verticleGreenHalf}
            src={VertGreenHalf}
            style={{
              zIndex: vertGreenHalfLine ? 1 : -1,
            }}
            alt=""
          />

          {/* <img
            src={HalfBlue}
            style={{
              height: "18%",
              top: 261,
              position: "absolute",
              left: 286,
              zIndex: vert1HalfBlue ? 1 : -1,
            }}
            alt=""
          /> */}

          {/* <img
            className={classes.horizontalBlue}
            src={HorBlue}
            style={{
              zIndex: horBlueLine ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.horizontalGreenLine}
            src={horGreen}
            style={{
              zIndex: horGreenLine ? 1 : -1,
            }}
            alt=""
          /> */}

          <img className={classes.HoriWhiteHalf25} src={horBlueHalf}
          style={{
            zIndex: horBlueLine ? 1 : -1,
          }}
          alt="" />
          <img className={classes.HoriWhiteHalf25} src={horGreenHalf}
          style={{
            zIndex: horGreenLine ? 1 : -1,
          }}
          alt="" />


          <img className={classes.HoriWhiteHalf22} src={horWhiteHalf} alt="" />
          <img className={classes.HoriWhiteHalf22} src={horBlueHalf}
          style={{
            zIndex: verticleBlueHalf22 ? 1 : -1,
          }}
          alt="" />
          <img className={classes.HoriWhiteHalf22} src={horGreenHalf}
          style={{
            zIndex: verticleGreenHalf22 ? 1 : -1,
          }}
          alt="" />
          <img className={classes.HoriWhiteHalf22} src={horRedHalf} 
          style={{
            zIndex: vertRedHalf22 ? 1 : -1,
          }}
          alt="" />

          <img className={classes.qsWhite} src={Q1WhiteCSPS} alt="" />

          <img
            className={classes.verticle2HalfBlue}
            src={HalfBlue}
            style={{
              zIndex: vert2HalfBlue ? 2 : -1,
            }}
            alt=""
          />

          <img
            className={classes.verticle1HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalfLine ? 2 : -1,
            }}
            alt=""
          />

          <img
            className={classes.verticleBlueHalf}
            src={HalfBlue}
            style={{
              zIndex: vertBlueLine ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.qoWhite} src={QoWhite} alt="" />

          <img
            className={classes.verticle1HalfBlue}
            src={HalfBlue}
            style={{
              zIndex: vert1HalfBlue ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.qdWhite}
            src={Q2WhiteCSPS}
            style={{
              zIndex: vert3HalfBlue ? -1 : 1,
            }}
            alt=""
          />

          <img
            className={classes.verticle3HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalf3Line ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.verticle3HalfBlue}
            src={QdHalfBlue}
            style={{
              zIndex: vert3HalfBlue ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.verticle2HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalf2Line ? 1 : -1,
            }}
            alt=""
          />

          {/* <img
            className={classes.horizontalRedLine}
            src={horRed}
            style={{
              zIndex: horRedLine ? 1 : -1,
            }}
            alt=""
          /> */}
          {/* <img className={classes.HoriWhiteHalf25} src={horRedHalf} 
          style={{
            zIndex: horRedLine ? 1 : -1,
          }}
          alt="" /> */}

          <img
            src={vertRed}
            style={{
              height: "34%",
              top: 195,
              right: 98,
              position: "absolute",
              zIndex: vertRedLine ? 1 : -1,
            }}
            alt=""
          />

          <div
            className={classes.shape1Major}
            // style={{
            //   clipPath: "polygon(0 7px, 49.1% 100%, 100% 4px)",
            //   shapeOutside: "polygon(0 7px, 49.1% 100%, 100% 4px)",
            // }}
          >
            <div
              className={classes.shape1}
              style={{
                float: "left",
                clipPath: "polygon(0 7px, 49.1% 100%, 100% 4px)",
                // shapeOutside: "polygon(0 7px, 49.1% 100%, 100% 4px)",
                backgroundColor: submitted
                  ? correctAnswer.includes(1)
                    ? "green"
                    : selected.includes(1)
                    ? "red"
                    : "#fff"
                  : selected.includes(1)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(1)
                  ? console.log("hhhh")
                  : !checkSelection(1) && resetBackground
              }
              onMouseOver={
                selected.includes(1)
                  ? console.log("1")
                  : !checkSelection(1) && changeBackground
              }
              onClick={() => markSelected(1)}
            />
          </div>

          <div className={classes.shape2Major}>
            <div
              className={classes.shape2}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "#fff"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("hhhh")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            />

            <div
              style={{
                width: 186.5,
                height: 62,
                overflow: "hidden",
                top: 147,
                position: "absolute",
                zIndex: 3,

                // zIndex: 1,
              }}
            >
              <div
                style={{
                  float: "left",
                  height: 62,
                  clipPath: "polygon(0 0, 100% 0, 54% 100%, 0 100%)",
                  shapeOutside: "polygon(0 0, 100% 0, 54% 100%, 0 100%)",
                  width: 180,
                  backgroundColor: submitted
                    ? correctAnswer.includes(3)
                      ? "green"
                      : selected.includes(3)
                      ? "red"
                      : "#fff"
                    : selected.includes(3)
                    ? "#00b1d9"
                    : "#fff",
                }}
                onMouseOut={
                  selected.includes(3)
                    ? console.log("hhhh")
                    : !checkSelection(3) && resetBackground
                }
                onMouseOver={
                  selected.includes(3)
                    ? console.log("3")
                    : !checkSelection(3) && changeBackground
                }
                onClick={() => markSelected(3)}
              ></div>
              <div
                style={{
                  float: "left",
                  height: 59,
                  clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
                  shapeOutside: "polygon(100% 0, 100% 100%, 0 100%)",
                  width: 79,
                  backgroundColor: submitted
                    ? correctAnswer.includes(4)
                      ? "green"
                      : selected.includes(4)
                      ? "red"
                      : "#fff"
                    : selected.includes(4)
                    ? "#00b1d9"
                    : "#fff",
                  position: "absolute",
                  left: 108,
                  top: 3.5,
                }}
                onMouseOut={
                  selected.includes(4)
                    ? console.log("hhhh")
                    : !checkSelection(4) && resetBackground
                }
                onMouseOver={
                  selected.includes(4)
                    ? console.log("4")
                    : !checkSelection(4) && changeBackground
                }
                onClick={() => markSelected(4)}
              ></div>
            </div>
          </div>

          <div className={classes.shape21Major}>
            <div
              className={classes.shape21}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                backgroundColor: submitted
                  ? correctAnswer.includes(21)
                    ? "green"
                    : selected.includes(21)
                    ? "red"
                    : "#fff"
                  : selected.includes(21)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(21)
                  ? console.log("hhhh")
                  : !checkSelection(21) && resetBackground
              }
              onMouseOver={
                selected.includes(21)
                  ? console.log("21")
                  : !checkSelection(21) && changeBackground
              }
              onClick={() => markSelected(21)}
            />
          </div>

          <div className={classes.shape22Major}>
            <div
              className={classes.shape22}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(22)
                    ? "green"
                    : selected.includes(22)
                    ? "red"
                    : "#fff"
                  : selected.includes(22)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(22)
                  ? console.log("hhhh")
                  : !checkSelection(22) && resetBackground
              }
              onMouseOver={
                selected.includes(22)
                  ? console.log("22")
                  : !checkSelection(22) && changeBackground
              }
              onClick={() => markSelected(22)}
            />
          </div>

          <div className={classes.shape5Major}>
            <div
              className={classes.shape5}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : "#fff"
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("hhhh")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            ></div>
          </div>

          <div className={classes.shape51Major}>
            <div
              className={classes.shape51}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(51)
                    ? "green"
                    : selected.includes(51)
                    ? "red"
                    : "#fff"
                  : selected.includes(51)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(51)
                  ? console.log("hhhh")
                  : !checkSelection(51) && resetBackground
              }
              onMouseOver={
                selected.includes(51)
                  ? console.log("51")
                  : !checkSelection(51) && changeBackground
              }
              onClick={() => markSelected(51)}
            ></div>
          </div>

          <div className={classes.shape6Major}>
            <div
              className={classes.shape6}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(6)
                    ? "green"
                    : selected.includes(6)
                    ? "red"
                    : "#fff"
                  : selected.includes(6)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(6)
                  ? console.log("hhhh")
                  : !checkSelection(6) && resetBackground
              }
              onMouseOver={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && changeBackground
              }
              onClick={() => markSelected(6)}
            ></div>
          </div>

          <div className={classes.shape7Major}>
            <div
              className={classes.shape7}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(7)
                    ? "green"
                    : selected.includes(7)
                    ? "red"
                    : "#fff"
                  : selected.includes(7)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(7)
                  ? console.log("hhhh")
                  : !checkSelection(7) && resetBackground
              }
              onMouseOver={
                selected.includes(7)
                  ? console.log("7")
                  : !checkSelection(7) && changeBackground
              }
              onClick={() => markSelected(7)}
            ></div>
          </div>

          <div className={classes.shape8Major}>
            <div
              className={classes.shape8}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 0 0, 0 100%)",
                shapeOutside: "polygon(100% 0, 0 0, 0 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(8)
                    ? "green"
                    : selected.includes(8)
                    ? "red"
                    : "#fff"
                  : selected.includes(8)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(8)
                  ? console.log("hhhh")
                  : !checkSelection(8) && resetBackground
              }
              onMouseOver={
                selected.includes(8)
                  ? console.log("8")
                  : !checkSelection(8) && changeBackground
              }
              onClick={() => markSelected(8)}
            ></div>
          </div>
          <div className={classes.shape9Major}>
            <div
              className={classes.shape9}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
                shapeOutside: "polygon(100% 0, 100% 100%, 0 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(9)
                    ? "green"
                    : selected.includes(9)
                    ? "red"
                    : "#fff"
                  : selected.includes(9)
                  ? "#00b1d9"
                  : "#fff",
                position: "absolute",
              }}
              onMouseOut={
                selected.includes(9)
                  ? console.log("hhhh")
                  : !checkSelection(9) && resetBackground
              }
              onMouseOver={
                selected.includes(9)
                  ? console.log("9")
                  : !checkSelection(9) && changeBackground
              }
              onClick={() => markSelected(9)}
            ></div>
          </div>
          <div className={classes.shape10Major}>
            <div
              className={classes.shape10}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                backgroundColor: submitted
                  ? correctAnswer.includes(10)
                    ? "green"
                    : selected.includes(10)
                    ? "red"
                    : "#fff"
                  : selected.includes(10)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(10)
                  ? console.log("hhhh")
                  : !checkSelection(10) && resetBackground
              }
              onMouseOver={
                selected.includes(10)
                  ? console.log("10")
                  : !checkSelection(10) && changeBackground
              }
              onClick={() => markSelected(10)}
            ></div>
          </div>

          <div className={classes.shape11Major}>
            <div
              className={classes.shape11}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                backgroundColor: submitted
                  ? correctAnswer.includes(11)
                    ? "green"
                    : selected.includes(11)
                    ? "red"
                    : "#fff"
                  : selected.includes(11)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(11)
                  ? console.log("hhhh")
                  : !checkSelection(11) && resetBackground
              }
              onMouseOver={
                selected.includes(11)
                  ? console.log("11")
                  : !checkSelection(11) && changeBackground
              }
              onClick={() => markSelected(11)}
            ></div>
          </div>

          <div className={classes.shape12Major}>
            <div
              className={classes.shape12}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(12)
                    ? "green"
                    : selected.includes(12)
                    ? "red"
                    : "#fff"
                  : selected.includes(12)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(12)
                  ? console.log("hhhh")
                  : !checkSelection(12) && resetBackground
              }
              onMouseOver={
                selected.includes(12)
                  ? console.log("12")
                  : !checkSelection(12) && changeBackground
              }
              onClick={() => markSelected(12)}
            ></div>
          </div>

          <div className={classes.shape13Major}>
            <div
              className={classes.shape13}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 0 0, 100% 100%)",
                shapeOutside: "polygon(100% 0, 0 0, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(13)
                    ? "green"
                    : selected.includes(13)
                    ? "red"
                    : "#fff"
                  : selected.includes(13)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(13)
                  ? console.log("hhhh")
                  : !checkSelection(13) && resetBackground
              }
              onMouseOver={
                selected.includes(13)
                  ? console.log("13")
                  : !checkSelection(13) && changeBackground
              }
              onClick={() => markSelected(13)}
            ></div>
          </div>

          <div className={classes.shape14Major}>
            <div
              className={classes.shape14}
              style={{
                float: "left",
                clipPath: "polygon(0 68%, 100% 0%, 100% 100%, 48% 100%)",
                shapeOutside: "polygon(0 68%, 100% 0%, 100% 100%, 48% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(14)
                    ? "green"
                    : selected.includes(14)
                    ? "red"
                    : "#fff"
                  : selected.includes(14)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(14)
                  ? console.log("hhhh")
                  : !checkSelection(14) && resetBackground
              }
              onMouseOver={
                selected.includes(14)
                  ? console.log("14")
                  : !checkSelection(14) && changeBackground
              }
              onClick={() => markSelected(14)}
            ></div>
          </div>
        </div>
      </div>
    );
  };

  return <Grid style={{ width: 565 }}>{demandCurveResponsive()}</Grid>;
};

export default withStyles(styles)(SecondGraph);
